module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-blue-2-fb1aa835f6c8921e93931e0ab382ffac.svg";